import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconTextFormat$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconTextFormat extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'e9e560a26a4a5a65080ac8a0d0df7d0e00284e62', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '9b1342005cf444c6746c5cb789a6d69a90711c6b', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '38be156a4d258a5c9b1ecd13e0636ddb51a1c050', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M12 5.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 .5.5V6a.5.5 0 0 1-.5.5h-6A.5.5 0 0 1 12 6zM7.137 9.225H5.508l.81-2.618zm-2.009 1.2h2.385l.343 1.049a.4.4 0 0 0 .38.276h.898a.3.3 0 0 0 .266-.439L7.284 5.354a.5.5 0 0 0-.47-.329h-1a.5.5 0 0 0-.47.328l-2.109 5.962a.3.3 0 0 0 .265.439h.892a.4.4 0 0 0 .379-.272zm7.372-.175a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h6a.5.5 0 0 0 .5-.5v-.5a.5.5 0 0 0-.5-.5zm-9 5.25a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h15a.5.5 0 0 0 .5-.5V16a.5.5 0 0 0-.5-.5z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-text-format", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-text-format"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-text-format":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconTextFormat$1);
            }
            break;
    } });
}

const CosmosIconTextFormat = CosmosIconTextFormat$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconTextFormat, defineCustomElement };
